import { Contract } from "../types";
import { Totals } from "../helpers";

function KpiCard({
  label,
  value,
  unit,
  hint,
  hintTone,
  dotColor,
}: {
  label: string;
  value: string;
  unit?: string;
  hint?: string;
  hintTone?: "neg" | "muted";
  dotColor: string;
}) {
  return (
    <div className="bg-white border border-[#E8EAEF] rounded-[10px] px-3.5 py-3 flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-[11px] tracking-wider text-[#828A99] font-semibold">
          {label}
        </span>
        <span
          className="w-2 h-2 rounded-full inline-block"
          style={{ background: dotColor }}
        />
      </div>
      <div className="text-[24px] font-bold text-[#525062] leading-tight">
        {value}
        {unit && (
          <span className="text-[12px] font-medium text-[#828A99] ml-1">
            {unit}
          </span>
        )}
      </div>
      {hint && (
        <div
          className={`text-[11px] ${
            hintTone === "neg" ? "text-[#E0463C] font-medium" : "text-[#828A99]"
          }`}
        >
          {hint}
        </div>
      )}
    </div>
  );
}

export function KpiRow({
  contract,
  totals,
  returnRequired,
  avgReturn,
}: {
  contract: Contract;
  totals: Totals;
  returnRequired: number;
  avgReturn: number;
}) {
  return (
    <div className="grid grid-cols-4 gap-3 mb-3.5 mt-3.5">
      <KpiCard
        label="SCHEDULED"
        value={totals.scheduled.toLocaleString()}
        unit="MWh"
        hint={`${totals.days} days`}
        dotColor="#0EA5A4"
      />
      <KpiCard
        label="ACTUAL SUPPLY"
        value={totals.actual.toLocaleString()}
        unit="MWh"
        hint={`▼ ${Math.abs(totals.varPct).toFixed(2)} % vs scheduled`}
        hintTone="neg"
        dotColor="#E2682B"
      />
      <KpiCard
        label="RETURN REQUIRED"
        value={returnRequired.toLocaleString()}
        unit="MWh"
        hint={`${contract.bf} factor`}
        dotColor="#6366F1"
      />
      <KpiCard
        label="AVG RETURN"
        value={avgReturn.toString()}
        unit="MW"
        hint={`${contract.returnDays}d × ${contract.returnHoursPerDay}h`}
        dotColor="#B47817"
      />
    </div>
  );
}

export default KpiRow;
